export default [
    {
        field: 'rut',
        type: 'rut',
        maxLength: 12,
        value: '',
        vuetifyProps: {
            textFieldProps: {
                label: 'RUT',
            },
        },
        rules: ['required'],
    },
]
